const RESET_PASSWORD_PATH = '/reset-password?token=';

export default () => new URL(RESET_PASSWORD_PATH, document.baseURI).href;
